export default (params) => {
    const tourCriteria = {};
    const element = params.isExclusive;
    if (element) {
        tourCriteria.isExclusive = true;
    }

    return tourCriteria;
};